/**
 * Prefer Apple Pay on product express checkout.
 * Filter Shop Pay, Google Pay, and PayPal out of cart wallet-configs.
 * Keep Apple Pay visible and re-init payment buttons after updates.
 */
(function preferApplePay() {
  var ATTR = 'data-prefer-apple-pay';
  var BLOCKED = { shop_pay: true, google_pay: true, paypal: true };

  var remounting = false;
  var appleConfigPromise = null;

  function applePayAvailable() {
    try {
      return Boolean(
        window.ApplePaySession &&
          typeof window.ApplePaySession.canMakePayments === 'function' &&
          window.ApplePaySession.canMakePayments()
      );
    } catch (error) {
      return false;
    }
  }

  function initPaymentButtons() {
    if (window.Shopify && window.Shopify.PaymentButton && window.Shopify.PaymentButton.init) {
      try {
        window.Shopify.PaymentButton.init();
      } catch (error) {}
    }
  }

  function pageApplePayConfig() {
    try {
      var el = document.getElementById('apple-pay-shop-capabilities');
      if (!el || !el.textContent) return null;
      return JSON.parse(el.textContent);
    } catch (error) {
      return null;
    }
  }

  function loadApplePayConfig() {
    if (!appleConfigPromise) {
      appleConfigPromise = fetch('/payments/config', { credentials: 'same-origin' })
        .then(function (response) {
          if (!response.ok) throw new Error('payments config ' + response.status);
          return response.json();
        })
        .then(function (data) {
          return data && data.paymentInstruments && data.paymentInstruments.applePayConfig
            ? data.paymentInstruments.applePayConfig
            : pageApplePayConfig();
        })
        .catch(function () {
          return pageApplePayConfig();
        });
    }
    return appleConfigPromise;
  }

  function buildWalletParams(config, el) {
    var shopId = Number(el.getAttribute('shop-id') || config.shopId || 0);
    var countryCode = el.getAttribute('buyer-country') || config.countryCode || 'CA';
    return {
      shopId: shopId,
      countryCode: countryCode,
      currencyCode: config.currencyCode || el.getAttribute('buyer-currency') || 'CAD',
      merchantCapabilities: config.merchantCapabilities || ['supports3DS'],
      merchantId: config.merchantId,
      merchantName: config.merchantName || 'PHOTO•MAGNET',
      shippingType: config.shippingType || 'shipping',
      supportedNetworks: config.supportedNetworks || [
        'visa',
        'masterCard',
        'amex',
        'discover',
        'jcb',
      ],
      shopifyPaymentsEnabled:
        typeof config.shopifyPaymentsEnabled === 'boolean' ? config.shopifyPaymentsEnabled : true,
      phoneRequired: false,
      companyRequired: false,
      emailRequired: true,
    };
  }

  function remount(el) {
    if (!customElements.get('shopify-accelerated-checkout') || !el.isConnected) return el;
    remounting = true;
    try {
      var clone = el.cloneNode(true);
      clone.removeAttribute(ATTR);
      el.replaceWith(clone);
      window.setTimeout(initPaymentButtons, 0);
      window.setTimeout(initPaymentButtons, 200);
      return clone;
    } finally {
      remounting = false;
    }
  }

  function filterCartWalletConfigs(el) {
    if (!(el instanceof Element)) return;
    if ((el.tagName || '').toLowerCase() !== 'shopify-accelerated-checkout-cart') return;
    var raw = el.getAttribute('wallet-configs');
    if (!raw || raw === 'null') return;
    try {
      var configs = JSON.parse(raw);
      if (!Array.isArray(configs)) return;
      var filtered = configs.filter(function (cfg) {
        return !(cfg && cfg.name && BLOCKED[cfg.name]);
      });
      if (filtered.length === configs.length) {
        el.setAttribute('data-mm-wallet-filtered', '1');
        return;
      }
      el.setAttribute('wallet-configs', JSON.stringify(filtered));
      el.setAttribute('data-mm-wallet-filtered', '1');
      if (el.isConnected && !el.getAttribute('data-mm-cart-remounted')) {
        el.setAttribute('data-mm-cart-remounted', '1');
        remounting = true;
        try {
          var clone = el.cloneNode(false);
          Array.from(el.attributes).forEach(function (attr) {
            clone.setAttribute(attr.name, attr.value);
          });
          el.replaceWith(clone);
          window.setTimeout(initPaymentButtons, 0);
          window.setTimeout(initPaymentButtons, 250);
        } finally {
          remounting = false;
        }
      }
    } catch (error) {}
  }

  function recommendedName(el) {
    var raw = el.getAttribute('recommended');
    if (!raw || raw === 'null') return null;
    try {
      var recommended = JSON.parse(raw);
      return recommended && recommended.name ? recommended.name : null;
    } catch (error) {
      return null;
    }
  }

  function showExpressBlock(el) {
    var block = el && el.closest && el.closest('.accelerated-checkout-block');
    if (!block) return;
    block.style.removeProperty('display');
    block.removeAttribute('data-mm-hidden-wallet');
    block.removeAttribute('hidden');
  }

  function hideBlockedProductWallet(el) {
    if (!(el instanceof Element)) return;
    var name = recommendedName(el);
    if (name !== 'shop_pay' && name !== 'google_pay' && name !== 'paypal') return;

    var block = el.closest('.accelerated-checkout-block');
    if (block) {
      block.style.setProperty('display', 'none', 'important');
      block.setAttribute('data-mm-hidden-wallet', name);
    }
  }

  function removePayPalNodes(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('.mm-paypal-checkout, [data-mm-paypal="1"]').forEach(function (el) {
      try {
        el.remove();
      } catch (error) {}
    });
  }

  function applyApplePay(el, config) {
    if (!(el instanceof Element) || !el.isConnected) return el;
    if (!applePayAvailable()) return el;

    var raw = el.getAttribute('recommended');
    if (!raw || raw === 'null') return el;

    var recommended;
    try {
      recommended = JSON.parse(raw);
    } catch (error) {
      return el;
    }
    if (!recommended || typeof recommended !== 'object') return el;

    var alreadyApple = recommended.name === 'apple_pay';
    var alreadyMarked = el.getAttribute(ATTR) === '1';

    // Already Apple Pay and hydrated — keep it visible, do not remount.
    if (alreadyApple && alreadyMarked) {
      showExpressBlock(el);
      return el;
    }

    var walletConfig = config || pageApplePayConfig() || {};
    recommended.name = 'apple_pay';
    recommended.supports_def_opts = false;
    recommended.wallet_params = buildWalletParams(walletConfig, el);
    el.setAttribute('recommended', JSON.stringify(recommended));
    el.setAttribute(ATTR, '1');
    showExpressBlock(el);

    if (alreadyApple) {
      initPaymentButtons();
      return el;
    }

    return remount(el) || el;
  }

  function enhance(el) {
    if (remounting) return;
    if (!(el instanceof Element)) return;
    if (el.matches && el.matches('shopify-accelerated-checkout-cart')) {
      filterCartWalletConfigs(el);
      return;
    }

    // Do NOT hide Shop Pay before Apple Pay mounts — that blanks the express
    // button when remount/config races. Hide blocked wallets only after.
    loadApplePayConfig().then(function (appleConfig) {
      if (!el.isConnected) return;
      var primary = applyApplePay(el, appleConfig);
      if (!primary || !primary.isConnected) {
        primary = document.querySelector('shopify-accelerated-checkout');
      }
      if (primary) {
        // Apple Pay replaced Shop Pay → showExpressBlock already ran.
        // Otherwise hide Shop Pay / Google Pay / PayPal so they stay off.
        hideBlockedProductWallet(primary);
      }
      removePayPalNodes(document);
    });
  }

  function scan(node) {
    if (!(node instanceof Element) && node !== document) return;
    var root = node && node.querySelectorAll ? node : document;
    removePayPalNodes(root);

    if (node instanceof Element) {
      if (node.matches && node.matches('shopify-accelerated-checkout-cart')) {
        filterCartWalletConfigs(node);
      }
      if (node.matches && node.matches('shopify-accelerated-checkout')) {
        enhance(node);
      }
    }

    if (root.querySelectorAll) {
      root.querySelectorAll('shopify-accelerated-checkout-cart').forEach(filterCartWalletConfigs);
      root.querySelectorAll('shopify-accelerated-checkout').forEach(enhance);
    }
  }

  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i += 1) {
      var mutation = mutations[i];
      for (var j = 0; j < mutation.addedNodes.length; j += 1) {
        var added = mutation.addedNodes[j];
        if (!(added instanceof Element)) continue;
        if (
          added.matches?.(
            'shopify-accelerated-checkout, shopify-accelerated-checkout-cart, .mm-paypal-checkout'
          ) ||
          added.querySelector?.(
            'shopify-accelerated-checkout, shopify-accelerated-checkout-cart, .mm-paypal-checkout'
          )
        ) {
          scan(added);
        }
      }
      if (
        mutation.type === 'attributes' &&
        mutation.target instanceof Element &&
        mutation.attributeName === 'wallet-configs'
      ) {
        filterCartWalletConfigs(mutation.target);
      }
    }
  });

  function boot() {
    scan(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['wallet-configs', 'recommended'],
  });

  if (customElements && customElements.whenDefined) {
    customElements.whenDefined('shopify-accelerated-checkout').then(boot).catch(function () {});
    customElements
      .whenDefined('shopify-accelerated-checkout-cart')
      .then(boot)
      .catch(function () {});
  }

  document.addEventListener(
    'click',
    function (event) {
      var target = event.target;
      if (!(target instanceof Element)) return;
      if (
        target.closest(
          '[data-testid="cart-drawer-trigger"], [aria-controls="cart-drawer"], #cart-icon-bubble, .header-actions__cart-icon'
        )
      ) {
        setTimeout(boot, 50);
        setTimeout(boot, 400);
      }
    },
    true
  );

  if (applePayAvailable()) loadApplePayConfig();
  window.addEventListener('load', boot);
})();
